(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vertaro-video-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vertaro-video-carousel')) {
  customElements.define('vertaro-video-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const track = this.querySelector('.vvc__track');
      const bar = this.querySelector('.vvc__progress span');
      const scrollbar = this.querySelector('.vvc__progress');
      let drag = null;
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);
        const portion = track.clientWidth / Math.max(track.scrollWidth, 1);
        bar.style.width = (portion * 100) + '%';
        bar.style.transform = 'translateX(' + (position / Math.max(track.clientWidth, 1) * 100) + '%)';
        scrollbar.setAttribute('aria-valuenow', String(Math.round(max > 0 ? Math.min(position / max, 1) * 100 : 0)));
        scrollbar.setAttribute('aria-disabled', String(max <= 1));
      };
      track.addEventListener('scroll', update, { ...options, passive: true });
      const setPosition = (position) => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        track.scrollLeft = Math.min(max, Math.max(0, position)) * (getComputedStyle(track).direction === 'rtl' ? -1 : 1);
      };
      const move = (event) => {
        if (!drag) return;
        const rect = scrollbar.getBoundingClientRect();
        const travel = rect.width - bar.getBoundingClientRect().width;
        if (travel > 0) setPosition((event.clientX - rect.left - drag.offset) / travel * (track.scrollWidth - track.clientWidth));
      };
      scrollbar.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || track.scrollWidth <= track.clientWidth + 1) return;
        const rect = bar.getBoundingClientRect();
        drag = { offset: event.target === bar ? event.clientX - rect.left : rect.width / 2 };
        track.style.scrollSnapType = 'none';
        scrollbar.setPointerCapture(event.pointerId);
        scrollbar.focus({ preventScroll: true });
        event.preventDefault();
        move(event);
      }, options);
      scrollbar.addEventListener('pointermove', move, options);
      const endDrag = () => {
        drag = null;
        track.style.removeProperty('scroll-snap-type');
      };
      scrollbar.addEventListener('pointerup', endDrag, options);
      scrollbar.addEventListener('pointercancel', endDrag, options);
      scrollbar.addEventListener('lostpointercapture', endDrag, options);
      scrollbar.addEventListener('keydown', (event) => {
        const position = Math.abs(track.scrollLeft);
        const page = track.clientWidth * .85;
        const targets = { ArrowRight: position + page, ArrowLeft: position - page, PageDown: position + page, PageUp: position - page, Home: 0, End: track.scrollWidth };
        if (Object.hasOwn(targets, event.key)) {
          event.preventDefault();
          setPosition(targets[event.key]);
        }
      }, options);
      this.querySelectorAll('.vvc__card').forEach(card => {
        const video = card.querySelector('video');
        const play = card.querySelector('.vvc__play');
        if (!video || !play) return;
        play.addEventListener('click', async () => {
          card.querySelector('.vvc__error').hidden = true;
          try {
            await video.play();
            play.hidden = true;
            video.focus();
          } catch {
            card.querySelector('.vvc__error').hidden = false;
          }
        }, options);
        video.addEventListener('play', () => {
          this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
          play.hidden = true;
        }, options);
        video.addEventListener('ended', () => { play.hidden = false; }, options);
      });
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      this.visibility = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
      }, { threshold: .1 });
      this.querySelectorAll('video').forEach(video => this.visibility.observe(video));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, options);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
